
import json from '#shared/util/json.js';
import logger from '#shared/util/logger.js';

import asyncCall from './asyncCall.js';

/**
 * Close window
 * @returns {Promise}
 */
export default function closeWindow() {
	return new Promise((resolve) => {
		const timeout = setTimeout(() => {
			if (typeof window.AvCommand === 'function') { // fallback for legacy client
				window.AvCommand('click_button:#close'); // eslint-disable-line new-cap
			} else {
				logger.warn({
					code: 'CLIENT',
					origin: 'closeWindow',
					detail: {
						description: 'Method AvCommand is not defined'
					}
				});
			}
		}, 1000);
		asyncCall('window.close', ([, error]) => { // call for modern client
			if (!error) {
				clearTimeout(timeout);
				resolve({});
			} else {
				logger.warn({
					code: 'CLIENT',
					origin: 'closeWindow',
					detail: json.parse(error) || {}
				});
			}
		});
	});
}
